export const GET_NOTIFICATIONS_FROM_PSYCHICS = 'customers/psychicnotifications/unread';
export const GET_EC_PSYCHIC_CATEGORIES = 'customers/<id>/psychic';
